// extracted by mini-css-extract-plugin
export var iconCategory = "IconPrefix-module--iconCategory--53a1e";
export var iconCheck = "IconPrefix-module--iconCheck--5c0b1";
export var iconColorAccent = "IconPrefix-module--iconColorAccent--89db0";
export var iconColorGray = "IconPrefix-module--iconColorGray--b9022";
export var iconContent = "IconPrefix-module--iconContent--f9ec8";
export var iconMethod = "IconPrefix-module--iconMethod--7fc57";
export var iconPeople = "IconPrefix-module--iconPeople--9a82b";
export var iconPlace = "IconPrefix-module--iconPlace--ee3e8";
export var iconPrefecture = "IconPrefix-module--iconPrefecture--d3959";
export var iconPrefix = "IconPrefix-module--iconPrefix--0b190";
export var iconSearch = "IconPrefix-module--iconSearch--bba20";
export var iconSizeLarge = "IconPrefix-module--iconSizeLarge--22421";
export var iconSizeSmall = "IconPrefix-module--iconSizeSmall--ae7f1";
export var iconSmartphone = "IconPrefix-module--iconSmartphone--66168";
export var iconSpecialist = "IconPrefix-module--iconSpecialist--34ec5";
export var iconTextSnippet = "IconPrefix-module--iconTextSnippet--ef276";
export var iconTime = "IconPrefix-module--iconTime--cb7e2";
export var iconWeb = "IconPrefix-module--iconWeb--ec728";